import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Text, { H2 } from 'components/common/Text/Text'
import Drawer from 'components/common/Drawer'
import Locations from './components'


const BOTRegionLocations = ({ regionName, locations = []}) =>
  <Wrapper>
    {
      regionName &&
      <Title block headline centered>{ regionName } Locations</Title>
    }
    {
      locations.map(({ stateName, stores = []}, index) =>
        <React.Fragment key={ stateName }>
          <Media.Desktop>
            <LocationWrapper key={ index }>
              {
                (locations.length > 1) &&
                <SubTitle block>{ stateName }</SubTitle>
              }
              <Locations stores={ stores } />
            </LocationWrapper>
          </Media.Desktop>
          <Media.Mobile>
            <LocationDrawer accordion title={ stateName }>
              <Locations stores={ stores } />
            </LocationDrawer>
          </Media.Mobile>
        </React.Fragment>
      )
    }
  </Wrapper>

BOTRegionLocations.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape()),
  regionName: PropTypes.string
}

BOTRegionLocations.type = 'BOTRegionLocations'

export default BOTRegionLocations


const Wrapper = styled.div`
  background: ${Theme.colors.off_white};
  ${Mixin.responsive('margin', '75px auto 40px', '35px 0 40px')}
  ${Mixin.responsive('padding', '35px 35px 13px', '35px 16px 40px')}
`

const Title = styled(H2)`
  ${Mixin.font.GothamBold(26, 600)}
  ${Mixin.responsive('margin', '0 0 20px', '0 0 15px')}
  ${Media.mobile`
    ${Mixin.font.GothamBold(20, 600)}
  `}
`

const SubTitle = styled(Text)`
  ${Mixin.responsive('margin-bottom', '20px', '15px')}
  ${Mixin.font.GothamBold(18, 600)}
  ${Media.mobile`
    ${Mixin.font.GothamBold(16, 600)}
  `}
`

const LocationWrapper = styled.div`
  & + & {
    margin-bottom: 20px;
  }
`

const LocationDrawer = styled(Drawer)`
  ${Media.mobile`
    padding: 25px 0px;
  `}
`
